import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";


export const TrendyolService = {

    async GetTrendYolOtpCode() {
        let response = await $axios.get($api("get_TrendyolOtpCode"), {
            headers: {
                "Accept-Language": "az",
                Authorization: `Bearer ${getCookie("ColibriToken")}`
            },
        })
            .catch((err) => {
                return err.response
            })
        return {
            data: response?.data ? response?.data : [],
            status: response?.status,
        };
    },
}